import React, { Fragment, useState } from 'react'

import { Paper, Typography } from '@mui/material';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import {
    agregarFC_36AnexoInstalacion,
    editarFC_36AnexoInstalacion,
    actualizarFC_36NumeroDeUnidades,
    obtenerSeccionesDeProduccion,
    /*eliminarDataElementoBD,
    eliminarResponsableBD,
    obtenerFC_01SolicitudDetalleConFiles,
    actualizarInstalaciones*/
} from '../../../redux/DucksBeneficiario/FC_36Ducks'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import estilos from './FormularioFC01Anexos.module.css';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ModalComponent from '../../App/ModalComponent'

import GuardarInstalacionComponent from './GuardarInstalacionComponent';
import { obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosConClaveApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerMunicipiosConClavePorEstadoApi, setCallesApi, setCodigosPostalesApi, setColoniasApi, setLocalidadesApi, setMunicipiosApi } from '../../../redux/DucksApis/CopomexDucks';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';


function FormularioFC36AnexoProduccionBeneficiarioComponent(props) {
    const dispatch = useDispatch()
    var fechaHoy = moment().format('YYYY-MM-DD');

    let dataDetalle = useSelector(store => store.FC_36Solicitud.dataDetalle)

    let idEditable = 0
    const [editInstalacion, setEditInstalacion] = useState(false)
    const [relacionInstalacion, setRelacionInstalacion] = useState(null)
    const [isedicion, setIsEdicion] = useState(false)
    if (props.history.location.state) {
        idEditable = props.history.location.state.idEdit
    }
    React.useEffect(() => {
        if (props.history.location.state?.idEdit) setEditInstalacion(true)
        if (props.history.location.state?.relacioncontacto) {
            setIsEdicion(true)
            setRelacionInstalacion(props.history.location.state?.relacioncontacto)
        }
        dispatch(obtenerEstadosConClaveApi())
    }, [])


    let anexoProduccionEditable = useSelector(store => store.FC_36Solicitud.instalaciones).filter(anexo => anexo.data.id === idEditable)
    const anexoProduccionFormato = useSelector(store => store.AtencionSolicitud.formato?.fc_36_anexounidaddeproduccion)?.filter(anexo => anexo.id === idEditable)
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)
    const anexoMap = useSelector(store => store.FC_36Solicitud.anexoUnidadMap)
    const anexoResponsablesMap = useSelector(store => store.FC_36Solicitud.anexoResponsableMap)
    const coccionFC_01 = useSelector(store => store.FC_36Solicitud.cocciones)
    const modoEdicionBorrador = useSelector(store => store.FC_36Solicitud.modoEdicionBorrador)

    const seccionesProduccion = useSelector(store => store.FC_36Solicitud.seccionesProduccion)
    let domicilioFiscal = useSelector(store => store.FC_36Solicitud.domicilioFiscal)
    let numeroDeUnidades = useSelector(store => store.FC_36Solicitud.numeroDeUnidades)

    //Municipios y estados validos
    const estadosDenominacionOrigen = useSelector(store => store.FC_36Solicitud.estadosDenominacionOrigen)
    const estadosDenominacion = useSelector(store => store.FC_36Solicitud.estadosDenominacion)
    const municipiosTamaulipas = useSelector(store => store.FC_36Solicitud.municipiosTamaulipas)
    const municipiosGuanajuato = useSelector(store => store.FC_36Solicitud.municipiosGuanajuato)
    const municipiosMichoacan = useSelector(store => store.FC_36Solicitud.municipiosMichoacan)
    const municipiosPuebla = useSelector(store => store.FC_36Solicitud.municipiosPuebla)

    //Api domicilio
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)

    React.useEffect(() => {
        if (idEditable = props.history.location.state?.idEdit === 0) {
            anexoProduccionEditable = []
            setEditInstalacion(false)
        }
    }, [props.history.location.state])

    const obtenerIdElemento = (data) => {
        for (const elemento of data.seccion.seccion.elementosdeseccion) {
            if (elemento.elemento.nombreelemento === data.valor) {
                return elemento.idelemento
            }
        }
        return null
    }
    // datos de las secciones de coccion
    const [opcionesSeleccionadosSeccion1, setOpcionesSeleccionadosSeccion1] = useStateIfMounted([])
    const [coccionProduccion, setCoccionProduccion] = useStateIfMounted([])

    const handleAddCoccionProduccion = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setCoccionProduccion([...coccionProduccion, anexo])
    };

    const handleOnChangueCoccionProduccion = (data) => {
        const input = coccionProduccion.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion1
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion1([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setCoccionProduccion([...coccionProduccion])

    }
    const deleteCoccionProduccion = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = coccionProduccion.filter(fields => fields.id !== inputField.id)
        setCoccionProduccion(fields)
        const opciones = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion1(opciones)
    }

    //datos para las secciones de molienda
    const [opcionesSeleccionadosSeccion2, setOpcionesSeleccionadosSeccion2] = useStateIfMounted([])
    const [moliendaProduccion, setMoliendaProduccion] = useStateIfMounted([])

    const handleAddMoliendaProduccion = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setMoliendaProduccion([...moliendaProduccion, anexo])
    };
    const handleOnChangueMoliendaProduccion = (data) => {
        const input = moliendaProduccion.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion2
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion2([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setMoliendaProduccion([...moliendaProduccion])
        // }
    }
    const deleteMoliendaProduccion = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = moliendaProduccion.filter(fields => fields.id !== inputField.id)
        setMoliendaProduccion(fields)
        const opciones = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion2(opciones)
    }

    //metodos para rellenar seccion de fermentacion
    const [opcionesSeleccionadosSeccion3, setOpcionesSeleccionadosSeccion3] = useStateIfMounted([])
    const [fermentacionProduccion, setFermentacionProduccion] = useStateIfMounted([])
    const handleAddFermentacionProduccion = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setFermentacionProduccion([...fermentacionProduccion, anexo])
    };

    const handleOnChangueFermentacionProduccion = (data) => {
        const input = fermentacionProduccion.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion3
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion3([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setFermentacionProduccion([...fermentacionProduccion])
        // }
    }
    const deleteFermentacionProduccion = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = fermentacionProduccion.filter(fields => fields.id !== inputField.id)
        setFermentacionProduccion(fields)
        const opciones = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion3(opciones)
    }
    //metodos agregar para la destilacion
    const [opcionesSeleccionadosSeccion4, setOpcionesSeleccionadosSeccion4] = useStateIfMounted([])
    const [destilacionProduccion, setDestilacionProduccion] = useStateIfMounted([])

    const handleAddDestilacionProduccion = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setDestilacionProduccion([...destilacionProduccion, anexo])
    };

    const handleOnChangueDestilacionProduccion = (data) => {
        const input = destilacionProduccion.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion4
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion4([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setDestilacionProduccion([...destilacionProduccion])
        // }
    }
    const deleteDestilacionProduccion = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = destilacionProduccion.filter(fields => fields.id !== inputField.id)
        setDestilacionProduccion(fields)
        const opciones = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion4(opciones)
    }

    //metodos para agregar los graneles
    const [opcionesSeleccionadosSeccion5, setOpcionesSeleccionadosSeccion5] = useStateIfMounted([])
    const [granelProduccion, setGranelProduccion] = useStateIfMounted([])

    const handleAddGranelProduccion = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setGranelProduccion([...granelProduccion, anexo])
    };

    const handleOnChangueGranelProduccion = (data) => {
        const input = granelProduccion.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion5
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== input[0].equipo)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion5([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setGranelProduccion([...granelProduccion])
        // }
    }
    const deleteGranelProduccion = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = granelProduccion.filter(fields => fields.id !== inputField.id)
        setGranelProduccion(fields)
        const opciones = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== inputField.equipo)
        setOpcionesSeleccionadosSeccion5(opciones)
    }

    //Metodos para los responsables
    const [responsables, setResponsables] = useStateIfMounted([])

    const deleteResponsable = (inputField) => {
        if (inputField.idfc_36responsabledeinstalacion) {
            dispatch(eliminarResponsableBD(inputField.idfc_36responsabledeinstalacion))
        }
        const fields = responsables.filter(fields => fields.id !== inputField.id)
        setResponsables(fields)
    }
    const handleAddResponsable = () => {
        let anexo = { id: uuidv4(), nombreresponsable: '', telefono: '', correoelectronico: '', estado: false }
        setResponsables([...responsables, anexo])
    };
    const handleOnChangueResponsable = (data) => {

        const input = responsables.filter(field => field.id === data.id)
        if (input.length > 0) {
            input[0][data.campo] = data.valor
            if (data.campo === 'correoelectronico') input[0]['estado'] = comprobarEmail(data.valor)
        }
        setResponsables([...responsables])
    }


    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [dictameninstalaciones, setdictameninstalaciones] = useStateIfMounted(true)
    const [actualizacioninformacion, setactualizacioninformacion] = useStateIfMounted(false)
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [fechapropuesta, setfechapropuesta] = useStateIfMounted(fechaHoy)
    const [instalacionnumero, setinstalacionnumero] = useStateIfMounted()
    const [tipoinstalacion, settipoinstalacion] = useStateIfMounted('')
    const [alias, setalias] = useStateIfMounted('')
    const [calle, setcalle] = useStateIfMounted('')
    const [otracalle, setotracalle] = useStateIfMounted('')
    const [numeroexterior, setnumeroexterior] = useStateIfMounted('')
    const [numerointerior, setnumerointerior] = useStateIfMounted('')
    const [colonia, setcolonia] = useStateIfMounted('')
    const [localidad, setlocalidad] = useStateIfMounted('')
    const [municipio, setmunicipio] = useStateIfMounted('')
    const [estado, setestado] = useStateIfMounted('')
    let [codigopostal, setcodigopostal] = useStateIfMounted()
    const [referenciascercanas, setreferenciascercanas] = useStateIfMounted('')
    let [telefono, settelefono] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const [nombreresponsable, setnombreresponsable] = useStateIfMounted('')
    const [hornopozo, sethornopozo] = useStateIfMounted(false)
    const [cantidadhornopozo, setcantidadhornopozo] = useStateIfMounted()
    const [capacidadhornopozo, setcapacidadhornopozo] = useStateIfMounted()
    const [hornomamposteria, sethornomamposteria] = useStateIfMounted(false)
    const [cantidadhornomamposteria, setcantidadhornomamposteria] = useStateIfMounted('')
    const [capacidadhornomamposteria, setcapacidadhornomamposteria] = useStateIfMounted('')
    const [autoclave, setautoclave] = useStateIfMounted(false)
    const [cantidadautoclave, setcantidadautoclave] = useStateIfMounted('')
    const [capacidadautoclave, setcapacidadautoclave] = useStateIfMounted('')
    const [otrococcion, setotrococcion] = useStateIfMounted(false)
    const [opcionotrococcion, setopcionotrococcion] = useStateIfMounted('')
    const [cantidadotrococcion, setcantidadotrococcion] = useStateIfMounted()
    const [capacidadotrococcion, setcapacidadotrococcion] = useStateIfMounted()
    const [mazomadera, setmazomadera] = useStateIfMounted(false)
    const [cantidadmazomadera, setcantidadmazomadera] = useStateIfMounted('')
    const [capacidadmazomadera, setcapacidadmazomadera] = useStateIfMounted('')
    const [tahonamolino, settahonamolino] = useStateIfMounted(false)
    const [cantidadhornotahonamolino, setcantidadhornotahonamolino] = useStateIfMounted()
    const [capacidadhornotahonamolino, setcapacidadhornotahonamolino] = useStateIfMounted()
    const [trapiche, settrapiche] = useStateIfMounted(false)
    const [cantidadtrapiche, setcantidadtrapiche] = useStateIfMounted('')
    const [capacidadtrapiche, setcapacidadtrapiche] = useStateIfMounted('')
    const [desgarradora, setdesgarradora] = useStateIfMounted(false)
    const [cantidaddesgarradora, setcantidaddesgarradora] = useStateIfMounted()
    const [capacidaddesgarradora, setcapacidaddesgarradora] = useStateIfMounted()
    const [trenmolinos, settrenmolinos] = useStateIfMounted(false)
    const [cantidadtrenmolinos, setcantidadtrenmolinos] = useStateIfMounted('')
    const [capacidadtrenmolinos, setcapacidadtrenmolinos] = useStateIfMounted('')
    const [difusor, setdifusor] = useStateIfMounted(false)
    const [cantidaddifusor, setcantidaddifusor] = useStateIfMounted()
    const [capacidaddifusor, setcapacidaddifusor] = useStateIfMounted()
    const [otromolienda, setotromolienda] = useStateIfMounted(false)
    const [opcionotromolienda, setopcionotromolienda] = useStateIfMounted('')
    const [cantidadotromolienda, setcantidadotromolienda] = useStateIfMounted('')
    const [capacidadotromolienda, setcapacidadotromolienda] = useStateIfMounted('')
    const [oquedadespiedra, setoquedadespiedra] = useStateIfMounted(false)
    const [cantidadoquedadespiedra, setcantidadoquedadespiedra] = useStateIfMounted('')
    const [capacidadoquedadespiedra, setcapacidadoquedadespiedra] = useStateIfMounted('')
    const [oquedadessuelo, setoquedadessuelo] = useStateIfMounted(false)
    const [cantidadoquedadessuelo, setcantidadoquedadessuelo] = useStateIfMounted()
    const [capacidadoquedadessuelo, setcapacidadoquedadessuelo] = useStateIfMounted()
    const [oquedadestronco, setoquedadestronco] = useStateIfMounted(false)
    const [cantidadoquedadestronco, setcantidadoquedadestronco] = useStateIfMounted('')
    const [capacidadoquedadestronco, setcapacidadoquedadestronco] = useStateIfMounted('')
    const [pielesanimal, setpielesanimal] = useStateIfMounted(false)
    const [cantidadpielesanimal, setcantidadpielesanimal] = useStateIfMounted()
    const [capacidadpielesanimal, setcapacidadpielesanimal] = useStateIfMounted()
    const [recipientesbarro, setrecipientesbarro] = useStateIfMounted(false)
    const [cantidadrecipientesbarro, setcantidadrecipientesbarro] = useStateIfMounted('')
    const [capacidadrecipientesbarro, setcapacidadrecipientesbarro] = useStateIfMounted('')
    const [recipientesmadera, setrecipientesmadera] = useStateIfMounted(false)
    const [cantidadrecipientesmadera, setcantidadrecipientesmadera] = useStateIfMounted()
    const [capacidadrecipientesmadera, setcapacidadrecipientesmadera] = useStateIfMounted()
    const [piletasmamposteria, setpiletasmamposteria] = useStateIfMounted(false)
    const [cantidadpiletasmamposteria, setcantidadpiletasmamposteria] = useStateIfMounted('')
    const [capacidadpiletasmamposteria, setcapacidadpiletasmamposteria] = useStateIfMounted('')
    const [tanquesacero, settanquesacero] = useStateIfMounted(false)
    const [cantidadtanquesacero, setcantidadtanquesacero] = useStateIfMounted()
    const [capacidadtanquesacero, setcapacidadtanquesacero] = useStateIfMounted()
    const [otrofermentacion, setotrofermentacion] = useStateIfMounted(false)
    const [opcionotrofermentacion, setopcionotrofermentacion] = useStateIfMounted('')
    const [cantidadotrofermentacion, setcantidadotrofermentacion] = useStateIfMounted('')
    const [capacidadotrofermentacion, setcapacidadotrofermentacion] = useStateIfMounted('')
    const [ollabarro, setollabarro] = useStateIfMounted(false)
    const [cantidadollabarro, setcantidadollabarro] = useStateIfMounted()
    const [capacidadollabarro, setcapacidadollabarro] = useStateIfMounted()
    const [ollamadera, setollamadera] = useStateIfMounted(false)
    const [cantidadollamadera, setcantidadollamadera] = useStateIfMounted('')
    const [capacidadollamadera, setcapacidadollamadera] = useStateIfMounted('')
    const [ollacobre, setollacobre] = useStateIfMounted(false)
    const [cantidadollacobre, setcantidadollacobre] = useStateIfMounted('')
    const [capacidadcobre, setcapacidadcobre] = useStateIfMounted('')
    const [ollaacero, setollaacero] = useStateIfMounted(false)
    const [cantidadollaacero, setcantidadollaacero] = useStateIfMounted()
    const [capacidadollaacero, setcapacidadollaacero] = useStateIfMounted()
    const [alambiquebarro, setalambiquebarro] = useStateIfMounted(false)
    const [cantidadalambiquebarro, setcantidadalambiquebarro] = useStateIfMounted('')
    const [capacidadalambiquebarro, setcapacidadalambiquebarro] = useStateIfMounted('')
    const [alambiquemadera, setalambiquemadera] = useStateIfMounted(false)
    const [cantidadalambiquemadera, setcantidadalambiquemadera] = useStateIfMounted()
    const [capacidadalambiquemadera, setcapacidadalambiquemadera] = useStateIfMounted()
    const [alambiquecobre, setalambiquecobre] = useStateIfMounted(false)
    const [cantidadalambiquecobre, setcantidadalambiquecobre] = useStateIfMounted('')
    const [capacidadalambiquecobre, setcapacidadalambiquecobre] = useStateIfMounted('')
    const [alambiquecalderaacero, setalambiquecalderaacero] = useStateIfMounted(false)
    const [cantidadalambiquecalderaacero, setcantidadalambiquecalderaacero] = useStateIfMounted('')
    const [capacidadalambiquecalderaacero, setcapacidadalambiquecalderaacero] = useStateIfMounted('')
    const [alambiqueacero, setalambiqueacero] = useStateIfMounted(false)
    const [cantidadalambiqueacero, setcantidadalambiqueacero] = useStateIfMounted()
    const [capacidadalambiqueacero, setcapacidadalambiqueacero] = useStateIfMounted()
    const [destiladorescontinuos, setdestiladorescontinuos] = useStateIfMounted(false)
    const [cantidaddestiladorescontinuos, setcantidaddestiladorescontinuos] = useStateIfMounted('')
    const [capacidaddestiladorescontinuos, setcapacidaddestiladorescontinuos] = useStateIfMounted('')
    const [columnacobre, setcolumnacobre] = useStateIfMounted(false)
    const [cantidadcolumnacobre, setcantidadcolumnacobre] = useStateIfMounted('')
    const [capacidadcolumnacobre, setcapacidadcolumnacobre] = useStateIfMounted('')
    const [columnaacero, setcolumnaacero] = useStateIfMounted(false)
    const [cantidadcolumnaacero, setcantidadcolumnaacero] = useStateIfMounted('')
    const [capacidadcolumnaacero, setcapacidadcolumnaacero] = useStateIfMounted('')
    const [anforasplastico, setanforasplastico] = useStateIfMounted(false)
    const [cantidadanforasplastico, setcantidadanforasplastico] = useStateIfMounted('')
    const [capacidadanforasplastico, setcapacidadanforasplastico] = useStateIfMounted('')
    const [tambosplasticos, settambosplasticos] = useStateIfMounted(false)
    const [cantidadtambosplasticos, setcantidadtambosplasticos] = useStateIfMounted('')
    const [capacidadtambosplasticos, setcapacidadtambosplasticos] = useStateIfMounted('')
    const [contenedoresplastico1000, setcontenedoresplastico1000] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico100, setcantidadcontenedoresplastico100] = useStateIfMounted()
    const [capacidadcontenedoresplastico10, setcapacidadcontenedoresplastico10] = useStateIfMounted()
    const [contenedoresplastico5000, setcontenedoresplastico5000] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico500, setcantidadcontenedoresplastico500] = useStateIfMounted('')
    const [capacidadcontenedoresplastico50, setcapacidadcontenedoresplastico50] = useStateIfMounted('')
    const [recipientesaceroinoxidable, setrecipientesaceroinoxidable] = useStateIfMounted(false)
    const [cantidadrecipientesaceroinoxida, setcantidadrecipientesaceroinoxida] = useStateIfMounted()
    const [capacidadrecipientesaceroinoxid, setcapacidadrecipientesaceroinoxid] = useStateIfMounted()
    const [otroalmacengraneles, setotroalmacengraneles] = useStateIfMounted(false)
    const [opcionotroalmacengraneles, setopcionotroalmacengraneles] = useStateIfMounted('')
    const [cantidadotroalmacengraneles, setcantidadotroalmacengraneles] = useStateIfMounted('')
    const [capacidadotroalmacengraneles, setcapacidadotroalmacengraneles] = useStateIfMounted('')
    const [idfc36_solicitudactualizacion, setidfc36_solicitudactualizacion] = useStateIfMounted('')
    const [idiformaciongeneral, setidiformaciongeneral] = useStateIfMounted("")

    React.useEffect(() => {
        let res = dispatch(obtenerSeccionesDeProduccion(1))
    }, [])


    const [isValid, setIsValid] = useStateIfMounted(false);
    const [message, setMessage] = useStateIfMounted('');

    // React.useEffect(() => {
    //     if (coccionFC_01.data) {
    //         if (coccionFC_01.data.data) {
    //             setcocciones(coccionFC_01.data.data)
    //         } else {
    //             setcocciones(coccionFC_01.data)
    //         }
    //     }
    // }, [coccionFC_01])
    React.useEffect(async () => {
        if (anexoProduccionEditable.length > 0) {
            const anexo = anexoProduccionEditable[0].data
            setalias(anexo.alias)
            setautoclave(anexo.autoclave)
            setcalle(anexo.calle)
            setotracalle(anexo.otracalle)
            setcodigopostal(anexo.codigopostal)
            setcolonia(anexo.colonia)
            setcorreoelectronico(anexo.correoelectronico)
            setdifusor(anexo.difusor)
            setestado(anexo.estado)
            setfechapropuesta(anexo.fechapropuesta)
            setfechasolicitud(anexo.fechasolicitud)
            setinstalacionnumero(anexo.instalacionnumero)
            setlocalidad(anexo.localidad)
            setmazomadera(anexo.mazomadera)
            setmunicipio(anexo.municipio)
            setnombrerazonsocial(anexo.nombrerazonsocial)
            setnombreresponsable(anexo.nombreresponsable)
            setnumeroexterior(anexo.numeroexterior)
            setnumerointerior(anexo.numerointerior)
            setidfc36_solicitudactualizacion(anexo.idfc36_solicitudactualizacion)
            setidiformaciongeneral(anexo.idiformaciongeneral)
            setreferenciascercanas(anexo.referenciascercanas)
            // settelefono(anexo.telefono)

            // if (anexo.correoelectronico !== null) comprobarEmail(anexo.correoelectronico)


            if (anexo.dataSeccion) {
                let auxElementosSeccion1 = []
                for (const elemento of anexo.dataSeccion.coccionProduccion) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion1.push(nuevoElemento)
                }
                setCoccionProduccion(auxElementosSeccion1)

                let auxElementosSeccion2 = []
                for (const elemento of anexo.dataSeccion.moliendaProduccion) {
                    const { opcion, cantidad, descripcion, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion2.push(nuevoElemento)
                }
                setMoliendaProduccion(auxElementosSeccion2)

                let auxElementosSeccion3 = []
                for (const elemento of anexo.dataSeccion.fermentacionProduccion) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion3.push(nuevoElemento)
                }
                setFermentacionProduccion(auxElementosSeccion3)

                let auxElementosSeccion4 = []
                for (const elemento of anexo.dataSeccion.destilacionProduccion) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion4.push(nuevoElemento)
                }
                setDestilacionProduccion(auxElementosSeccion4)

                let auxElementosSeccion5 = []
                for (const elemento of anexo.dataSeccion.granelProduccion) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion5.push(nuevoElemento)
                }
                setGranelProduccion(auxElementosSeccion5)

                setOpcionesSeleccionadosSeccion1(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion1)
                setOpcionesSeleccionadosSeccion2(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion2)
                setOpcionesSeleccionadosSeccion3(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion3)
                setOpcionesSeleccionadosSeccion4(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion4)
                setOpcionesSeleccionadosSeccion5(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion5)
            }
            if (anexo.responsables) {
                let auxResponsables = []
                for (const responsable of anexo.responsables) {
                    const { nombreresponsable, telefono, correoelectronico, estado, idiformaciongeneral, idfc_36responsabledeinstalacion } = responsable
                    const nuevoResponsable = {
                        id: uuidv4(), nombreresponsable: nombreresponsable, telefono: telefono, correoelectronico: correoelectronico, estado: estado,
                        idiformaciongeneral: idiformaciongeneral, idfc_36responsabledeinstalacion: idfc_36responsabledeinstalacion
                    }
                    auxResponsables.push(nuevoResponsable)
                }
                setResponsables(auxResponsables)
            }

            await dispatch(actualizarLoadingApp_true())
            // const result = await obtenerEstadosConClave()
            await cargarDomicilioApi(anexo)
            await dispatch(actualizarLoadingApp_false())
        } else {
            if (anexoProduccionFormato) {
                const anexo = anexoProduccionFormato[0]

                setalias(anexo.alias)
                setcalle(anexo.calle)
                setotracalle(anexo.otracalle)
                setcodigopostal(anexo.codigopostal)
                setcolonia(anexo.colonia)

                setcorreoelectronico(anexo.correoelectronico)

                setdictameninstalaciones(anexo.dictameninstalaciones)
                setdifusor(anexo.difusor)
                setestado(anexo.estado)
                setfechapropuesta(anexo.fechapropuesta)
                setfechasolicitud(anexo.fechasolicitud)
                sethornomamposteria(anexo.hornomamposteria)
                setinstalacionnumero(anexo.instalacionnumero)
                setlocalidad(anexo.localidad)
                setmunicipio(anexo.municipio)
                setnombrerazonsocial(anexo.nombrerazonsocial)
                setnombreresponsable(anexo.nombreresponsable)
                setnumeroexterior(anexo.numeroexterior)
                setnumerointerior(anexo.numerointerior)
                setrecipientesaceroinoxidable(anexo.recipientesaceroinoxidable)
                setrecipientesbarro(anexo.recipientesbarro)
                setrecipientesmadera(anexo.recipientesmadera)
                setreferenciascercanas(anexo.referenciascercanas)
                settelefono(anexo.telefono)
            }
        }
    }, [])

    React.useEffect(() => {
        if (instalacionnumero === '' || instalacionnumero === undefined && anexoProduccionEditable.length === 0) {
            setinstalacionnumero(numeroDeUnidades + 1)
        }
    }, [])



    const cargarDomicilioApi = async (anexo) => {
        var municipiosConClave = []
        if (anexo.estado !== '') {
            const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(anexo.estado))
            municipiosConClave = result.payload
        }
        if (anexo.municipio !== '') {
            const result = await dispatch(obtenerCPsPorMunicipioApi(anexo.municipio))
        }
        if (anexo.codigopostal !== '') {
            //anexo.codigopostal
            const result = await dispatch(obtenerColoniasPorCpApi(anexo.codigopostal))
        }
        var localidadesConClave = []
        if (anexo.codigopostal !== '') {
            const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: anexo.estado, municipio: anexo.municipio }))
            localidadesConClave = result.payload
        }
        if (anexo.localidad !== '') {
            const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, anexo.estado)
            const clave_municipio = await obtenerClaveDomicilio(municipiosConClave, anexo.municipio, "municipio")
            const clave_localidad = await obtenerClaveDomicilio(localidadesConClave, anexo.localidad, "localidad")
            const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        }
    }

    const [errors, setErrors] = useStateIfMounted({})
    const validarAnexo = () => {
        let errores = {}
        // instalacionnumero, alias, calle, numeroexterior, numerointerior,
        //     colonia, localidad, municipio, estado, codigopostal, referenciascercanas
        const textoError = 'Campo obligratorio'
        if (alias === '') { errores.alias = textoError }
        if (calle === '') { errores.calle = textoError }
        else if (calle === 'Otro' && otracalle === '') { errores.otracalle = textoError }

        if (numeroexterior === '') { errores.numeroexterior = textoError }
        // if (numerointerior === '') { errores.numerointerior = textoError }
        // if (colonia === '') { errores.colonia = textoError }
        if (localidad === '') { errores.localidad = textoError }
        if (municipio === '') { errores.municipio = textoError }
        if (estado === '') { errores.estado = textoError }
        if (codigopostal === '') { errores.codigopostal = textoError }
        if (referenciascercanas === '') { errores.referenciascercanas = textoError }
        setErrors(errores)
        if (JSON.stringify(errores) !== '{}') {
            return false
        }
        if (!validarResponsables()) return false
        if (!validarSecciones()) return false
        return true
    }

    const validarResponsables = () => {
        if (responsables.length === 0) return false
        for (let responsable of responsables) {
            if (responsable.nombre === '' || (responsable.telefono + '') === '' || (responsable.telefono + '').length !== 10 ||
                responsable.correoelectronico === '' || !comprobarEmail(responsable.correoelectronico)) {
                return false
            }
        }
        return true
    }
    const validarSecciones = () => {
        if (!validarSeccion(coccionProduccion)) return false
        if (!validarSeccion(moliendaProduccion)) return false
        if (!validarSeccion(fermentacionProduccion)) return false
        if (!validarSeccion(destilacionProduccion)) return false

        return true
    }
    const validarSeccion = (seccion) => {
        if (seccion.length === 0) return false
        for (let anexo of seccion) {
            if (anexo.opcion === '' || (anexo.cantidad + '') === '' || anexo.descripcion === '' || anexo.otro === '') {
                return false
            }
        }
        return true
    }

    const validarDomicilio = async (data) => {
        const {
            estado,
            municipio
        } = data
        if (await validarEstadoDenominacionOrigen(estado)) return true
        if (await validarEstadoDenominacion(estado)) {
            switch (estado) {
                case 'Tamaulipas':
                    if (await validarMunicipiosTamaulipas(municipio)) return true
                    break;
                case 'Guanajuato':
                    if (await validarMunicipiosGuanajuato(municipio)) return true
                    break;
                case 'Michoacán de Ocampo':
                    if (await validarMunicipiosMichoacan(municipio)) return true
                    break;
                case 'Puebla':
                    if (await validarMunicipiosPuebla(municipio)) return true
                    break;
                default:
                    break;
            }
        }
        return false
    }

    const validarEstadoDenominacionOrigen = async (estado) => {
        if (await estadosDenominacionOrigen.includes(estado)) return true
        return false
    }
    const validarEstadoDenominacion = async (estado) => {
        if (estadosDenominacion.includes(estado)) return true
        return false
    }
    const validarMunicipiosTamaulipas = async (municipio) => {
        if (municipiosTamaulipas.includes(municipio)) return true
        return false
    }
    const validarMunicipiosGuanajuato = async (municipio) => {
        if (municipiosGuanajuato.includes(municipio)) return true
        return false
    }
    const validarMunicipiosMichoacan = async (municipio) => {
        if (municipiosMichoacan.includes(municipio)) return true
        return false
    }
    const validarMunicipiosPuebla = async (municipio) => {
        if (municipiosPuebla.includes(municipio)) return true
        return false
    }
    const botonEditarAnexoProduccion = async () => {
        if (!validarAnexo()) return
        // telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')y
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        const dataSeccion = {
            coccionProduccion,
            moliendaProduccion,
            fermentacionProduccion,
            destilacionProduccion,
            granelProduccion
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5
        }
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle == 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '

        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        if (!isedicion) {
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoProduccionEditable[0].data.idanexo,
                id: idEditable,
                relacioncontacto: relacionInstalacion,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia,
                localidad, municipio, estado, codigopostal, referenciascercanas,
                dataSeccion, opcionesSeleccionadas, idfc36_solicitudactualizacion, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Producción', isedicion: isedicion, baja: false, alta: true
            }))
        } else {
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoProduccionEditable[0].data.idanexo,
                id: idEditable,
                relacioncontacto: relacionInstalacion,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia,
                localidad, municipio, estado, codigopostal, referenciascercanas,
                dataSeccion, opcionesSeleccionadas, idfc36_solicitudactualizacion, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Producción', isedicion: isedicion, baja: false, alta: false
            }))
        }

        //await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))
        props.history.push('/fc_36')
    }
    const botonActualizarAnexoProduccion = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')

        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        let datosdireccion = {
            idiformaciongeneral: anexoProduccionEditable?.[0]?.data?.idiformaciongeneral, calle: calle, otracalle: otracalle, numeroexterior: numeroexterior, numerointerior: numerointerior,
            colonia: colonia, localidad: localidad, municipio: municipio,
            estado: estado, codigopostal: codigopostal
        }
        await dispatch(actualizarInstalaciones({
            datosdireccion: datosdireccion, responsables: responsables
        }))
        await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))
        props.history.push('/fc_36')
    }

    const botonAgregarAnexoProduccion = async () => {
        const dataSeccion = {
            coccionProduccion,
            moliendaProduccion,
            fermentacionProduccion,
            destilacionProduccion,
            granelProduccion
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5
        }

        //telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'

        if (instalacionnumero > numeroDeUnidades) {
            await dispatch(actualizarFC_36NumeroDeUnidades(instalacionnumero))
        }
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        const res = await dispatch(agregarFC_36AnexoInstalacion({
            id: uuidv4(),
            //fechasolicitud,
            instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior,
            relacioncontacto: null,
            colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
            idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas,
            domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
            tipoInstalacion: 'Unidad Producción', isedicion: isedicion, baja: false, alta: true
        }))
        props.history.push('/fc_36')
    }
    const botonAgregarOtroAnexoProduccion = async () => {
        if (anexoProduccionEditable.length === 0) {
            const dataSeccion = {
                coccionProduccion,
                moliendaProduccion,
                fermentacionProduccion,
                destilacionProduccion,
                granelProduccion
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5
            }

            //telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'

            if (instalacionnumero > numeroDeUnidades) {
                await dispatch(actualizarFC_36NumeroDeUnidades(instalacionnumero))
            }
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = await validarDomicilio(data)
            const res = await dispatch(agregarFC_36AnexoInstalacion({
                id: uuidv4(),
                relacioncontacto: null,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior,
                colonia, localidad, municipio, estado, codigopostal, referenciascercanas,
                idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Producción'
            }))

            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
            const dataSeccion = {
                coccionProduccion,
                moliendaProduccion,
                fermentacionProduccion,
                destilacionProduccion,
                granelProduccion
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5
            }
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = await validarDomicilio(data)
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoProduccionEditable[0].data.idanexo,
                id: idEditable,
                relacioncontacto: relacionInstalacion,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia,
                localidad, municipio, estado, codigopostal, referenciascercanas,
                dataSeccion, opcionesSeleccionadas, idfc36_solicitudactualizacion, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Producción'
            }))
            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            idEditable = 0
            anexoProduccionEditable = []
            setEditInstalacion(false)
            props.history.location.state.idEdit = undefined
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    //Obtener estados de la API


    //Metodos Api Copomex

    const obtenerEstadosConClave = async () => {
        const result = await dispatch(obtenerEstadosConClaveApi())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }

    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }


    const handleResetAllPropertys = () => {
        setalias('')
        setcalle('')
        setotracalle('')
        setcodigopostal('')
        setcolonia('')
        setcorreoelectronico('')
        setestado('')
        setlocalidad('')
        setmunicipio('')
        setnumeroexterior('')
        setnumerointerior('')
        setidfc36_solicitudactualizacion('')
        setidiformaciongeneral('')
        setreferenciascercanas('')
        settelefono('')
        setResponsables([])
        setCoccionProduccion([])
        setMoliendaProduccion([])
        setFermentacionProduccion([])
        setDestilacionProduccion([])
        setGranelProduccion([])
        setOpcionesSeleccionadosSeccion1([])
        setOpcionesSeleccionadosSeccion2([])
        setOpcionesSeleccionadosSeccion3([])
        setOpcionesSeleccionadosSeccion4([])
        setOpcionesSeleccionadosSeccion5([])
    }

    const botonRegresarFC_36 = async () => {
        /*if (modoCorreccion) {
            await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))
        }*/
        props.history.push('/fc_36')
    }

    const usarDomicilioFiscal = async () => {
        await dispatch(setMunicipiosApi(domicilioFiscal.municipiosApi))
        await dispatch(setCodigosPostalesApi(domicilioFiscal.codigosPostalesApi))
        await dispatch(setColoniasApi(domicilioFiscal.coloniasApi))
        await dispatch(setLocalidadesApi(domicilioFiscal.localidadesApi))
        await dispatch(setCallesApi(domicilioFiscal.callesApi))

        setcalle(domicilioFiscal.calle)
        setotracalle(domicilioFiscal.otracalle)
        setcodigopostal(domicilioFiscal.codigopostal)
        setcolonia(domicilioFiscal.colonia)
        setestado(domicilioFiscal.estado)
        setlocalidad(domicilioFiscal.localidad)
        setmunicipio(domicilioFiscal.municipioalcaldia)
        setnumeroexterior(domicilioFiscal.numeroexterior)
        setnumerointerior(domicilioFiscal.numerointerior)
    }

    const validateEmail = (event) => {
        const email = event.target.value;
        comprobarEmail(email);

    };

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;

        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }

    }
    return (
        <Fragment >
            <div className='container containerFixed' style={{ marginLeft: '8%' }}>
                <div className='row ms-1 mt-1'>
                    <div className='row mt-1'>
                        <div className={`${estilos.botonRegresar} col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-4`}>
                            <button
                                onClick={botonRegresarFC_36}
                                className='btn  btnNaranja'>Regresar</button>
                        </div>
                        <div className='col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mt-3'>
                            {
                                !editInstalacion ?
                                    (
                                        <h2 className='ms-5'>Unidad de Producción</h2>) :
                                    (
                                        <h4 className='ms-5'><strong>Editando</strong> Unidad de Producción</h4>
                                    )
                            }
                        </div>

                    </div>
                    <div className='row align-items-center mt-2 mb-4'>

                        <div className={`${estilos.labelNaranjaInstalacion} row mb-2`}>
                            <div className='col-md-8'>
                                <h5 className='text-end'>Información de la instalación</h5>
                            </div>
                            {/*<div className='col-md-4 text-end'>
                                <Tooltip title="Usar el domicilio fiscal sí la instalación se encuentra ubicada en el mismo domicilio." arrow>
                                    <button onClick={e => usarDomicilioFiscal()} className="btn btnNaranja zoom-in-zoom-out">
                                        Usar domicilio fiscal
                                    </button>
                                </Tooltip>
                        </div>*/}
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={instalacionnumero} onChange={e => setinstalacionnumero(e.target.valueAsNumber)}
                                    type="number"
                                    className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                    id="" placeholder='Número de instalación' disabled
                                    onWheel={event => event.currentTarget.blur()} />
                                <label className="floatingInput">Instalación numero</label>
                            </div>
                        </div>

                        <div className='col-xs-12 col-sm-12 col-md-10 col-lg-9 col-xl-9 col-xxl-9'>
                            <div className="form-floating mb-3">
                                <input
                                    value={alias} onChange={e => setalias(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                    id="" placeholder='Nombre de la instalacion'
                                    name='alias'
                                    onBlur={validarAnexo}
                                />
                                {errors.alias && <div className="text-danger">{errors.alias}</div>}
                                <label className='floatingInput'>
                                    Alias: <i>(Asignar un "Alias" para identificar cada instalación, esto permitirá diferenciarlas)
                                    </i></label>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-start'>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={estado}
                                    onChange={e => {
                                        setestado(e.target.value)
                                        setmunicipio('')
                                        setcodigopostal('')
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)
                                    }} name="estado"
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                    onBlur={validarAnexo} >
                                    <option value="">Seleccione su estado</option>
                                    {estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                        <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>
                                    ))
                                    }
                                </select>
                                {errors.estado && <div className="text-danger">{errors.estado}</div>}
                                {
                                    anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Estado</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">

                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={municipio}
                                    onChange={e => {
                                        setmunicipio(e.target.value)
                                        setcodigopostal('')
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                    }}
                                    name="municipio"
                                    onBlur={validarAnexo}
                                    disabled={estado === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su municipio</option>
                                    {
                                        municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                            <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.municipio && <div className="text-danger">{errors.municipio}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Delegación/Municipio</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={codigopostal}
                                    onChange={e => {
                                        setcodigopostal(e.target.value)
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerColonias(e.target.value)
                                        if (e.target.value !== '') obtenerLocalidades({ estado: estado, municipio: municipio })
                                    }}
                                    name="codigopostal"
                                    onBlur={validarAnexo}
                                    disabled={municipio === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su código postal</option>
                                    {
                                        codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                            <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.codigopostal && <div className="text-danger">{errors.codigopostal}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Código Postal</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">

                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={colonia}
                                    onChange={e => {
                                        setcolonia(e.target.value)
                                    }}
                                    name="colonia"
                                    onBlur={validarAnexo}
                                    disabled={codigopostal === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su colonia</option>
                                    {
                                        coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                            <option key={index} value={`${colonia}`}>{`${colonia}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.colonia && <div className="text-danger">{errors.colonia}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Colonia</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">

                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={localidad}
                                    onChange={e => {
                                        setlocalidad(e.target.value)
                                        setcalle('')
                                        if (e.target.value !== '') obtenerCalles({ clave_estado: estado, clave_municipio: municipio, clave_localidad: localidad })
                                    }}
                                    name="localidad"
                                    onBlur={validarAnexo}
                                    disabled={codigopostal === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su localidad</option>
                                    {
                                        localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                            <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.localidad && <div className="text-danger">{errors.localidad}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Localidad</label>
                            </div>
                        </div>
                        <div className={`col-xs-12 col-sm-12 ${calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1 col-xxl-1' : 'col-md-6 col-lg-6 col-xl-6 col-xxl-6'}`}>
                            <div className="form-floating mb-3">

                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={calle}
                                    onChange={e => {
                                        setcalle(e.target.value)
                                    }}
                                    name="calle"
                                    onBlur={validarAnexo}
                                    disabled={localidad === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su calle</option>
                                    {
                                        callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                            <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                        ))
                                    }
                                    <option value="Otro">Otro</option>
                                </select>
                                {errors.calle && <div className="text-danger">{errors.calle}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Calle</label>
                            </div>
                        </div>
                        {
                            calle === 'Otro' &&
                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                <div className="form-floating mb-3">
                                    <input type="text" id="floatingInput"
                                        // onChange={e => setNumExterior(e.target.value)}
                                        //     value={numeroexterior}
                                        className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                            (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        placeholder='Calle'
                                        name="otracalle"
                                        value={otracalle}
                                        onChange={e => setotracalle(e.target.value)}
                                        onBlur={validarAnexo}
                                        disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                    />
                                    {errors.otracalle && <div className="text-danger">{errors.otracalle}</div>}
                                    { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                    <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                                </div>
                            </div>
                        }
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={numeroexterior} onChange={e => setnumeroexterior(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                        (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Número exterior'
                                    onBlur={validarAnexo}
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false} />
                                {errors.numeroexterior && <div className="text-danger">{errors.numeroexterior}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Número exterior</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={numerointerior} onChange={e => setnumerointerior(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                        (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Número interior'
                                    onBlur={validarAnexo}
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false} />
                                {errors.numerointerior && <div className="text-danger">{errors.numerointerior}</div>}
                                { anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Numero interior</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <input
                                    value={referenciascercanas} onChange={e => setreferenciascercanas(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${anexoMap?.validacioncheck ? 'inputValidado' : ''}`}
                                    id="" placeholder='Indique los lugares cercanos que permitan localizar con facilidad sus instalaciones, o las calles entre las que se encuentra.'
                                    onBlur={validarAnexo}
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false} />
                                {errors.referenciascercanas && <div className="text-danger">{errors.referenciascercanas}</div>}
                                <label className="floatingInput">Referencias cercanas</label>
                                {/* <span className={`${anexoMap.length>0?(anexoMap[0].validacioncheck===true? 'text-danger':'text-success') :('')}`}>{anexoMap?.domicilio}</span> */}
                            </div>
                        </div>

                    </div>
                    <div className='divRedondeadoNaranja'>
                        <h5 className={`text-center  ${estilos.labelNaranjaInstalacion} mt-3`}>Responsables de la instalación</h5>
                    </div>
                    {
                        responsables.map((inputField, index) => (
                            <div key={index} className='row'>
                                <div className='col-md-4'>
                                    <div className="form-floating mb-3">
                                        <input type="text"
                                            className={`form-control ${anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                === inputField.idfc_36responsabledeinstalacion)[0]?.validacioncheck !== undefined ? (anexoResponsablesMap?.filter
                                                    (map => map.idfc_36responsabledeinstalacion === inputField.idfc_36responsabledeinstalacion)[0]?.validacioncheck ?
                                                    'inputDenegado' : 'inputValidado') : ('')}`}
                                            onChange={e =>
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'nombreresponsable'
                                                    })}
                                            disabled={isedicion}
                                            value={inputField.nombreresponsable}
                                            id="" placeholder='Nombre del responsable'
                                        />
                                        {inputField.nombreresponsable.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                        <label className="floatingInput">Nombre completo del responsable</label>
                                        <span className={`${anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion === inputField?.idfc_36responsabledeinstalacion)[0]?.validacioncheck !== undefined ? (
                                            anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion === inputField?.idfc_36responsabledeinstalacion)[0]?.validacioncheck ? 'text-danger'
                                                : 'text-success') : ('')}`}>{anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                    === inputField.idfc_36responsabledeinstalacion)[0]?.validacioncheck ? (anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                        === inputField?.idfc_36responsabledeinstalacion)[0]?.observacion) : ''}</span>
                                    </div>
                                </div>

                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                    <div className="form-floating mb-3">
                                        <input type="number"
                                            className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                            onChange={e => e.target.value.length < 11 ? (
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'telefono'
                                                    })) : ''}
                                            disabled={isedicion}
                                            value={inputField.telefono}
                                            id="" placeholder='Telefono'
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                        {inputField.telefono.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : inputField.telefono.length !== 10 ? (<span className='text-danger'>Debe contener 10 digitos</span>) : ''}
                                        <label className="floatingInput">Teléfono</label>
                                    </div>
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                    <div className="form-floating mb-3">
                                        <input type="email"
                                            className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                            onChange={e =>
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'correoelectronico'
                                                    })
                                            }
                                            disabled={isedicion}
                                            value={inputField.correoelectronico}
                                            id="" placeholder='Correo'
                                        />
                                        <label className="floatingInput">Correo electrónico</label>
                                        {
                                            inputField.correoelectronico === '' ?
                                                <div className={`message text-danger`}>
                                                    Campo obligatorio
                                                </div>
                                                :
                                                <div key={index} className={`message ${(inputField.estado) ? estilos.success : estilos.error}`}>
                                                    {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                </div>
                                        }
                                    </div>
                                </div>
                                {(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false ? '' :
                                    <Fragment>
                                        {!modoCorreccion &&
                                            <div className='col-md-1'>
                                                <ModalComponent api={{ deleteAnexo: deleteResponsable, inputField }} text="un responsable de instalción" />
                                            </div>
                                        }
                                    </Fragment>}
                            </div>
                        ))
                    }
                    {(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false ? '' :
                        <Fragment>
                            {!modoCorreccion &&
                                (
                                    <div className='row justify-content-start'>
                                        <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarAnexo col-md-3' onClick={e =>
                                                handleAddResponsable()}>Agregar responsable</button>
                                            {responsables.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                        </div>
                                    </div>
                                )
                            }</Fragment>}

                    <div className='container'>
                        <div className='divRedondeadoNaranja'>
                            <h6 className={`text-center ${estilos.labelNaranjaInstalacion}`}>Descripción de la instalación</h6>
                        </div>
                        {
                            seccionesProduccion.map((inputField, index) => (

                                <div key={index} className='row'>
                                    <div className='divBorderNaranja ms-3 me-3'>
                                        <h3 className={`text-center ${estilos.labelSeccion}`}><b>{`${inputField.seccion.nombre}`}</b></h3>
                                    </div>
                                    {
                                        index === 0 &&
                                        coccionProduccion.map((coccionProduccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${coccionProduccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={coccionProduccion.opcion}
                                                            onChange={e => handleOnChangueCoccionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: coccionProduccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion1.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {/* {coccionProduccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''} */}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    coccionProduccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueCoccionProduccion(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: coccionProduccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                value={coccionProduccion.otro}
                                                                id="" />
                                                            {(coccionProduccion.otro === '' || coccionProduccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueCoccionProduccion(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: coccionProduccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={coccionProduccion.cantidad}
                                                            id=""
                                                            disabled={coccionProduccion.opcion === '' || coccionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {coccionProduccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad </label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueCoccionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: coccionProduccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={coccionProduccion.descripcion}
                                                            id=""
                                                            disabled={coccionProduccion.opcion === '' || coccionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {coccionProduccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Toneladas)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteCoccionProduccion(coccionProduccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteCoccionProduccion, inputField: coccionProduccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {index === 1 &&
                                        moliendaProduccion.map((moliendaProduccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${moliendaProduccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={moliendaProduccion.opcion}
                                                            onChange={e => handleOnChangueMoliendaProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: moliendaProduccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion2.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i}
                                                                        value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}
                                                                    </option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {moliendaProduccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    moliendaProduccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueMoliendaProduccion(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: moliendaProduccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={moliendaProduccion.otro}
                                                                id="" />
                                                            {(moliendaProduccion.otro === '' || moliendaProduccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueMoliendaProduccion(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: moliendaProduccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={moliendaProduccion.cantidad}
                                                            id=""
                                                            disabled={moliendaProduccion.opcion === '' || moliendaProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {moliendaProduccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueMoliendaProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: moliendaProduccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={moliendaProduccion.descripcion}
                                                            id=""
                                                            disabled={moliendaProduccion.opcion === '' || moliendaProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {moliendaProduccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Toneladas/día)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteMoliendaProduccion(moliendaProduccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteMoliendaProduccion, inputField: moliendaProduccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        index === 2 &&

                                        fermentacionProduccion.map((fermentacionProduccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${fermentacionProduccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={fermentacionProduccion.opcion}
                                                            onChange={e => handleOnChangueFermentacionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: fermentacionProduccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion3.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {fermentacionProduccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    fermentacionProduccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueFermentacionProduccion(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: fermentacionProduccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={fermentacionProduccion.otro}
                                                                id="" />
                                                            {(fermentacionProduccion.otro === '' || fermentacionProduccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueFermentacionProduccion(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: fermentacionProduccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={fermentacionProduccion.cantidad}
                                                            id=""
                                                            disabled={fermentacionProduccion.opcion === '' || fermentacionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {fermentacionProduccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueFermentacionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: fermentacionProduccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={fermentacionProduccion.descripcion}
                                                            id=""
                                                            disabled={fermentacionProduccion.opcion === '' || fermentacionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {fermentacionProduccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Litros)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteFermentacionProduccion(fermentacionProduccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteFermentacionProduccion, inputField: fermentacionProduccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        index === 3 &&

                                        destilacionProduccion.map((destilacionProduccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${destilacionProduccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={destilacionProduccion.opcion}
                                                            onChange={e => handleOnChangueDestilacionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: destilacionProduccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion4.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {destilacionProduccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>

                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueDestilacionProduccion(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: destilacionProduccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={destilacionProduccion.cantidad}
                                                            id=""
                                                            disabled={destilacionProduccion.opcion === '' || destilacionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {destilacionProduccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueDestilacionProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: destilacionProduccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={destilacionProduccion.descripcion}
                                                            id=""
                                                            disabled={destilacionProduccion.opcion === '' || destilacionProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {destilacionProduccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Litros)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteDestilacionProduccion(destilacionProduccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteDestilacionProduccion, inputField: destilacionProduccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        index === 4 &&

                                        granelProduccion.map((granelProduccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${granelProduccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={granelProduccion.opcion}
                                                            onChange={e => handleOnChangueGranelProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: granelProduccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion5.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {granelProduccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    granelProduccion.equipo === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueGranelProduccion(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: granelProduccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={granelProduccion.otro}
                                                                id="" />
                                                            {(granelProduccion.otro === '' || granelProduccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueGranelProduccion(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: granelProduccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={granelProduccion.cantidad}
                                                            id=""
                                                            disabled={granelProduccion.opcion === '' || granelProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {granelProduccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueGranelProduccion(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: granelProduccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={granelProduccion.descripcion}
                                                            id=""
                                                            disabled={granelProduccion.opcion === '' || granelProduccion.opcion === undefined ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {granelProduccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Toneladas)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteGranelProduccion(granelProduccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteGranelProduccion, inputField: granelProduccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    <div className='container'>
                                        {
                                            (index === 0/* && isedicion*/) &&
                                            <div className='mb-1 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-2' onClick={e =>
                                                    handleAddCoccionProduccion()}>Agregar</button>
                                                <br />
                                                {coccionProduccion.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                <br />
                                                <hr />
                                            </div>
                                        }
                                        {
                                            (index === 1 /*&& isedicion*/) &&
                                            <div className='mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-2' onClick={e =>
                                                    handleAddMoliendaProduccion()}>Agregar</button>
                                                <br />
                                                {moliendaProduccion.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                <hr />
                                            </div>
                                        }
                                        {
                                            (index === 2 /*&& isedicion*/) &&
                                            <div className='mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-2' onClick={e =>
                                                    handleAddFermentacionProduccion()}>Agregar</button>
                                                <br />
                                                {fermentacionProduccion.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                <hr />
                                            </div>
                                        }
                                        {
                                            (index === 3 ) &&
                                            <div className='mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-2' onClick={e =>
                                                    handleAddDestilacionProduccion()}>Agregar</button>
                                                <br />
                                                {destilacionProduccion.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                <hr />
                                            </div>
                                        }
                                        {
                                            (index === 4 ) &&
                                            <div className='mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-2' onClick={e =>
                                                    handleAddGranelProduccion()}>Agregar</button>
                                                <br />
                                                {granelProduccion.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                <hr />
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div className="row mt-5 ms-2">
                        {
                            anexoProduccionEditable.length === 0 ? (
                                <div className='text-center'>

                                    <GuardarInstalacionComponent
                                        guardarInstacion={botonAgregarAnexoProduccion}
                                        agregarOtraInstalacion={botonAgregarOtroAnexoProduccion}
                                        unidad={'producción'}
                                        validarUnidad={validarAnexo}
                                        texto={'Guardar'} />
                                </div>
                            ) :
                                (
                                    <div className='text-center'>
                                        {
                                            !modoCorreccion ?
                                                <GuardarInstalacionComponent
                                                    guardarInstacion={botonEditarAnexoProduccion}
                                                    agregarOtraInstalacion={botonAgregarOtroAnexoProduccion}
                                                    unidad={'producción'}
                                                    validarUnidad={validarAnexo}
                                                    texto={'Guardar cambios'}
                                                />
                                                :
                                                <button
                                                    onClick={() => botonActualizarAnexoProduccion()}
                                                    type='submit'
                                                    className={`btn btnNaranja`}> Guardar cambios
                                                </button>
                                        }
                                    </div>
                                )
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default withRouter(FormularioFC36AnexoProduccionBeneficiarioComponent)
